module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--width text-dark",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Vælg jeres lønsystem")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader', {
    attrs: {
      "bgColor": "#f6f9fc"
    }
  })], 1) : _c('div', {
    staticClass: "d-boxes"
  }, _vm._l((_vm.systems), function(system) {
    return _c('div', {
      staticClass: "d-box-select",
      on: {
        "click": function($event) {
          return _vm.select(system)
        }
      }
    }, [_vm._v("\n          " + _vm._s(system.name) + "\n        ")])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77d4b4dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/ChooseSalarySystem.vue
// module id = 1685
// module chunks = 1